import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import {Container, Stack} from "@mui/material";
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import Grid from '@mui/material/Grid';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs'; // Import dayjs

import TextField from "@mui/material/TextField";


const Landing = () => {

    const token = localStorage.getItem('token');

    const [festival, setFestival] = useState('1');
    const [history, setHistory] = useState('All');
    const [rows, setRows] = useState([]);
    const [years , setYears] = useState([])
    const [year, setYear] = useState('2026');
    const [movie, setMovie] = useState([])
    const [imageUrl, setImageUrl] = useState([]);
    const [dateSeen, setDateSeen] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const navigate = useNavigate();


    // Table contents

    const columns = [
        //{ field: 'Id', headerName: 'ID', width: 70 },
        { field: 'Year', headerName: 'Year', width: 70 },
        { field: 'Title', headerName: 'Title', width: 260 },
        { field: 'Director', headerName: 'Director', width: 200 },
        { field: 'Genre', headerName: 'Genre', width: 200 },
        { field: 'Runtime', headerName: 'Runtime', type: 'number', width: 70 },
        { field: 'NoNominations', headerName: 'Nominations', type: 'number', width: 130 },
        { field: 'NoAwards', headerName: 'Awards', type: 'number', width: 130 },
    ];

    const open = Boolean(anchorEl);

    const isAdmin = localStorage.getItem('x') === "1";

    const getRowIdFromInternalId = (row) => row.Id;

    const paginationModel = { page: 0, pageSize: 10 };

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleMenuClose = () => {
        setAnchorEl(null);
    }

    const handleRowClick = (params) => {
        console.log('Row id:', params.id);
        retrieveMovieData(params.id);
        retrieveSeenDate(params.id);
    };

    const handleFestivalChange = (event) => {
        setFestival(event.target.value);
        retrieveTableData(event.target.value, year, history);
        clearMovieDetail();
    };

    const handleHistoryChange = (event) => {
        setHistory(event.target.value);
        retrieveTableData(festival, year, event.target.value);
        clearMovieDetail();
    };

    const handleYearChange = (event) => {
        setYear(event.target.value);
        retrieveTableData(festival, event.target.value, history);
        clearMovieDetail();
    };

    const handleMenuLogout = () => {
        handleMenuClose();
        localStorage.setItem('token', "");
        localStorage.setItem('email', "");
        localStorage.setItem('x', "");
        navigate('/');
    }

    const handleMenuAbout = () => {
        handleMenuClose();
        navigate("/about")
    }

    const handleMenuProfile = () => {
        handleMenuClose();
        navigate("/profile")
    }

    const handleMenuAdvancedSearch= () => {
        handleMenuClose();
        navigate('/advancedSearch')
    }

    const handleMenuUserManagement = () => {
        handleMenuClose();
        navigate("/userManagement")
    }

    const handleDateClear = () => {
        setDateSeen(null);
    }

    const clearMovieDetail = () => {
        console.log("Entering clearMovieDetail")
        const movie = {
            AwardCategory: "",
            NominationCategory: "",
            Overview: "",
            Posterpath: "",
            RtScore: "",
            ImdbScore: ""
        }
        setMovie(movie);
        setImageUrl("");
        setDateSeen(null);
        console.log("Leaving clearMovieDetail");
    }

    const handleDateChange = async (newValue) => {
        setDateSeen(newValue);
        const dateString = newValue ? newValue.format('MM/DD/YYYY') : '';
        console.log('New date: ', dateString);
        try {
            const movieId = movie.ID.toString();
            console.log("Movie id: ", movieId);

            const response = await fetch('/api/updateSeenDate', {
                method: 'POST',
                headers: {'Authorization': 'Bearer ' + token},
                body: JSON.stringify({movieId, dateString}),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const json = await response.json();
            console.log('Response: ', json);

        } catch (err) {
            console.error(err);
        }
    }

    const retrieveTableData = async (festivalId, year, history) => {
        try {
            const baseUrl = '/api/getMovies';
            const url = new URL(baseUrl, window.location.origin);
            url.searchParams.append('festivalId', festivalId);
            url.searchParams.append("year", year);
            url.searchParams.append("history", history);

            const response  = await fetch(url,{
                method: 'GET',
                headers: {'Authorization': 'Bearer ' + token}
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const json = await response.json();
            // console.log('Table data', json);
            setRows(json);

        } catch (err) {
            console.error(err);
        }
    };

    const retrieveYears = async ()  => {
        try {
            const response  = await fetch(`/api/getYears`,{
                method: 'GET',
                headers: {'Authorization': 'Bearer ' + token}
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const json = await response.json();
            console.log('Year data', json);
            setYears(json);
        } catch (err) {
            console.error(err);
        }
    }

    const retrieveMovieData = async (movieId)  => {
        try {
            const baseUrl = '/api/getMovie';
            const url = new URL(baseUrl, window.location.origin);
            url.searchParams.append('movieId', movieId);
            const response  = await fetch(url,{
                method: 'GET',
                headers: {'Authorization': 'Bearer ' + token}
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const json = await response.json();
            console.log('Movie data', json);
            setMovie(json);
            const posterPath = json.PosterPath;
            console.log('Poster URL: ', posterPath);
            const fullPosterPath = "https://image.tmdb.org/t/p/w185" + posterPath;
            setImageUrl(fullPosterPath);
            console.log('Full poster path: ', fullPosterPath);
        } catch (err) {
            console.error(err);
        }
    }

    const retrieveSeenDate = async(movieId) => {
        console.log("Entering retrieveSeenDate");
        const baseUrl = '/api/getSeenDate';
        const url = new URL(baseUrl, window.location.origin);
        url.searchParams.append('movieId', movieId.toString());
        const response  = await fetch(url,{
            method: 'GET',
            headers: {'Authorization': 'Bearer ' + token}
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const json = await response.json();
        const seenDate = json.Date;
        console.log('Seen Data: ', seenDate);
        if (seenDate === '') {
            setDateSeen(null);
        }
        else {
            const format = "MM/DD/YYYY";
            const dateObject = dayjs(seenDate, format);
            setDateSeen(dateObject);
        }
    }

    useEffect(() => {
        retrieveYears();
        retrieveTableData(festival, year, history);

    }, []);
    return (
        <Container component="main" maxWidth="lg">
            <Box sx={{ flexGrow: 1 }}>
                <AppBar position="static">
                    <Toolbar>
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ mr: 2 }}
                            aria-haspopup="true"
                            aria-controls={open ? 'popup-menu' : undefined}
                            aria-expanded={open ? 'true' : undefined}
                            onClick={handleMenuClick}
                        >
                            <MenuIcon />
                        </IconButton>
                        {/* The actual MUI Menu component */}
                        <Menu
                            id="popup-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleMenuClose}
                            // Keep the menu mounted in the DOM when closed for potential performance benefits
                            // You can remove keepMounted if you prefer it to unmount
                            keepMounted
                            MenuListProps={{
                                'aria-labelledby': 'menu-button',
                            }}
                        >
                            {/* Menu Items */}
                            <MenuItem onClick={handleMenuAbout}>
                                <Typography variant="inherit">About</Typography>
                            </MenuItem>
                            <MenuItem onClick={handleMenuProfile}>
                                <Typography variant="inherit">Profile</Typography>
                            </MenuItem>
                            <MenuItem onClick={handleMenuAdvancedSearch}>
                                <Typography variant="inherit">Advanced Search</Typography>
                            </MenuItem>
                            {isAdmin && <MenuItem onClick={handleMenuUserManagement}><Typography variant="inherit">User Management</Typography></MenuItem>}
                            <MenuItem onClick={handleMenuLogout}>
                                <Typography variant="inherit">Logout</Typography>
                            </MenuItem>
                        </Menu>

                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                            Festival Nominees
                        </Typography>
                    </Toolbar>
                </AppBar>
            </Box>
            <Box sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                margin: 4,
            }}
            >
                <Stack direction="row" spacing={20}>
                    <FormControl style={{minWidth: 200}}>
                        <InputLabel id="festival-select-label">Festival</InputLabel>
                        <Select
                            labelId="festival-select-label"
                            id="festival-simple-select"
                            value={festival}
                            label="Festival"
                            onChange={handleFestivalChange}
                        >
                            <MenuItem value={1}>Academy Awards</MenuItem>
                            <MenuItem value={2}>Cannes</MenuItem>
                            <MenuItem value={3}>Sundance</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl style={{minWidth: 200}}>
                        <InputLabel id="year-select-label">Year</InputLabel>
                        <Select
                            labelId="year-select-label"
                            id="year-simple-select"
                            value={year}
                            label="Year"
                            onChange={handleYearChange}
                        >
                            {years.map((option) => (
                                <MenuItem key={option} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl style={{minWidth: 200}}>
                        <InputLabel id="history-select-label">History</InputLabel>
                        <Select
                            labelId="history-select-label"
                            id="history-simple-select"
                            value={history}
                            label="History"
                            onChange={handleHistoryChange}
                        >
                            <MenuItem value={'All'}>All</MenuItem>
                            <MenuItem value={'Seen'}>Seen</MenuItem>
                            <MenuItem value={'Unseen'}>Unseen</MenuItem>
                        </Select>
                    </FormControl>
                </Stack>
            </Box>
            <Paper sx={{ height: 630, width: '100%' }}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    getRowId={getRowIdFromInternalId}
                    onRowClick={handleRowClick}
                    disableMultipleRowSelection={true}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[5,10]}
                    checkboxSelection
                    sx={{ border: 0 }}
                />
            </Paper>
            <Paper sx={{ flexGrow: 1, width: '100%', padding: 4, marginTop: 2}}>
                <Grid container spacing={2}>
                    <Grid size={3}>
                        <Box
                            component="img"
                            sx={{
                                height: 337,
                                width: 222,
                                //maxHeight: { xs: 400, md: 150 }, // Optional: responsive height
                                //maxWidth: { xs: '100%', md: 250 }, // Optional: responsive max width
                                objectFit: 'cover', // Ensures the image covers the area without stretching
                                borderRadius: '4px', // Optional: adds slight rounding
                            }}
                            alt="Select a movie from the table above"
                            src={imageUrl}
                        />
                    </Grid>
                    <Grid size={9}>
                        <Stack spacing={2}>
                            <TextField
                                id="nominations"
                                label="Nominations"
                                variant="outlined"
                                slotProps={{
                                    inputLabel: {
                                        shrink: true,
                                    },
                                }}
                                fullWidth
                                multiline
                                maxRows={4}
                                value={movie.NominationCategory}
                            />
                            <TextField
                                id="awards"
                                label="Awards"
                                variant="outlined"
                                slotProps={{
                                    inputLabel: {
                                        shrink: true,
                                    },
                                }}
                                fullWidth
                                multiline
                                maxRows={4}
                                value={movie.AwardCategory}
                            />
                            <TextField
                                id="movieOverview"
                                label="Overview"
                                variant="outlined"
                                slotProps={{
                                    inputLabel: {
                                        shrink: true,
                                    },
                                }}
                                fullWidth
                                multiline
                                maxRows={6}
                                value={movie.Overview}
                            />
                        </Stack>
                    </Grid>
                    <Grid size={4}>
                        <TextField
                            id="imdbRating"
                            label="IMDB Rating"
                            variant="outlined"
                            slotProps={{
                                inputLabel: {
                                    shrink: true,
                                },
                            }}
                            fullWidth
                            multiline
                            maxRows={4}
                            value={movie.ImdbScore}
                        />
                    </Grid>
                    <Grid size={4}>
                        <TextField
                            id="rtScore"
                            label="Rotten Tomatoes Rating"
                            variant="outlined"
                            slotProps={{
                                inputLabel: {
                                    shrink: true,
                                },
                            }}
                            fullWidth
                            multiline
                            maxRows={4}
                            value={movie.RtScore}
                        />
                    </Grid>
                    <Grid size={4}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Date Seen"
                                slotProps={{
                                    field: {
                                        clearable: true,
                                        onClear: handleDateClear,
                                    },
                                    textField: {
                                        InputLabelProps: {
                                            shrink: true, // This keeps the label at the top
                                        },
                                    },
                                }}
                                value={dateSeen}
                                onChange={handleDateChange}
                            />
                        </LocalizationProvider>
                    </Grid>
                </Grid>
            </Paper>
        </Container>

    );
};

export default Landing;